<template>
  <div style="margin: 4px 16px 16px;">
    <div class="content-input" style="margin-bottom: 8px;">
      <div class="content-input-left">
        <div class="dialog-input-item">
          <label>添加门店</label>
          <el-select v-model="copyToShopId" placeholder="Select" class="select-item">
            <el-option v-for="item in copyToShopIdArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="dialog-input-item">
          <label>复用门店</label>
          <el-select v-model="copyShopId" placeholder="Select" class="select-item" @change="getPage(true)">
            <el-option v-for="item in copyShopIdArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="content-input-right">
        <div class="dialog-input-btn">
          <el-button type="primary" @click="submit" v-loading="subLoading"> 一键复用 </el-button>
          <!--          <el-button type="success" @click="add">添加</el-button>-->
        </div>
      </div>
    </div>
    <div v-if="copyShopId">
      <el-table
          ref="multipleTableRef"
          :data="pageDataList"
          style="width: 100%; "
          v-loading="listLoading"
          @cell-click="toggleSelection"
          @selection-change="selsChange"
          @header-click="selsAll"
          size="default"
          height="560"
          :row-key="rowKey"
      >
        <el-table-column type="selection" width="55" align="center" class-name="cursor" :reserve-selection="true"/>
        <el-table-column property="" label="服务类型" width="140">
          <template #default="scope">
            <p>{{scope.row.serviceTypeName}}</p>
          </template>
        </el-table-column>
        <el-table-column property="name" label="项目名称"/>
        <el-table-column property="projectNo" label="类型" width="80">
          <template #default="scope">
            <p>{{scope.row.projectType == 1?'金额':scope.row.projectType == 2?'张数':''}}</p>
          </template>
        </el-table-column>
        <el-table-column property="content" label="价格">
          <template #default="scope">
<!--            {{ scope.row.projectType == 1?scope.row.price:''}}-->
            <el-input v-if="scope.row.projectType == 1" v-model="scope.row.price" placeholder="请输入价格" @input="priceChange(scope.row)"/>
          </template>
        </el-table-column>
        <el-table-column property="orderNum" label="排序">
          <template #default="scope">
            <el-input v-model="scope.row.orderNum" placeholder="请输入排序" @input="orderChange(scope.row)"/>
          </template>
        </el-table-column>
      </el-table>
      <!--分页-->
<!--      <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalRow" style="text-align:right;margin-top: 24px;">-->
<!--      </el-pagination>-->
      <div style="margin-top: 8px">共 {{idArray.length}} 项</div>
    </div>

  </div>
</template>

<script>
import { getFormData,postJson } from '@/api/api';
import {getAllShopList, getProjectAllPageList, getRecordShops, shopProjectListAll, copyShopProject, getProjectTypeAndPrice} from '@/api/url';
import Dialog from '@/assets/js/dialog'
import Drawer from '@/assets/js/drawer'
// import AddUserRemarkDialog from './AddUserRemarkDialog';
import DatePickerRange from "@/components/DatePickerRange_30";
import SearchComponents from "@/components/SearchComponents";
import PayDetailDialog from "@/views/user/components/payment/PayDetailDialog";
import ProjectDetailDialog from "@/views/user/components/project/ProjectDetailDialog";
import EditPaymentDialog from "@/views/user/components/payment/EditPaymentDialog";
import EditProjectDialog from "@/views/user/components/project/EditProjectDialog";
export default {
  props: {
    value: Object
  },
  components: {DatePickerRange, SearchComponents},
  data() {
    return {
      pageDataList: [],
      totalRow: 0,
      pageSize: 20,
      currentPage: 1,
      listLoading: false,
      searchLoading: false,


      copyToShopIdArray: JSON.parse(sessionStorage.getItem('ownShopList')),
      copyToShopId: '',

      copyShopIdArray: [],
      copyShopId: '',

      idArray: [],

      subLoading: false,

    }
  },
  methods: {

    rowKey (row) {
      return row.id;
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.projectId);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.projectId) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    toggleSelection(row, column, cell, event) {
      if (column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }
    },

    priceChange(row) {
      if(!row.price) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '价格不能为空',
          type: 'warning'
        })
        row.price = row.oldPrice
      }
    },

    orderChange(row) {
      if(!row.orderNum) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '排序不能为空',
          type: 'warning'
        })
        row.orderNum = row.oldOrderNum
      }

    },


    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
          this.idArray = []
          this.$refs.multipleTableRef.clearSelection()
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['shopId'] = this.copyShopId;
      param['userId'] = 0;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getProjectTypeAndPrice, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result;
          this.pageDataList.map(item => {
            item.oldPrice = item.price
            item.oldOrderNum = item.orderNum
          })
          // this.pageDataList.sort(this.compare)
          // this.totalRow = result['total'];
          // this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    submit() {
      if(!this.copyToShopId) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请选择添加的门店',
          type: 'warning'
        })
        return false
      }
      if(!this.copyShopId) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请选择复用的门店',
          type: 'warning'
        })
        return false
      }
      if(this.idArray.length == 0) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请勾选项目',
          type: 'warning'
        })
        return false
      }
      this.subLoading = true
      let copyReqList = []
      this.pageDataList.map(item => {
        if(this.idArray.indexOf(item.projectId) > -1) {
          let obj = {}
          obj.projectId = item.projectId
          if(item.projectType == 1) {
            obj.price = Number(item.price)
          }
          obj.orderNum = Number(item.orderNum)
          copyReqList.push(obj)
        }
      })
      let param = {}
      param['copyShopId'] = this.copyShopId
      param['copyToShopId'] = this.copyToShopId
      param['shopProjectCopyReqList'] = copyReqList
      postJson(copyShopProject,param).then(data => {
        let {msg, code } = data;
        if(code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          })
          this.$emit('confirm')
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.subLoading = false;
      })
    },

    getShopList() {
      getFormData(getAllShopList).then(data=> {
        this.copyShopIdArray = data.data.filter(item => item.id != 0)
        this.copyShopId = this.copyShopIdArray[0].id
        this.getPage()
      })
    },

  },
  mounted() {
    this.getShopList()
    // this.getPage();
  }
}
</script>

<style>

</style>
